module.exports = {"address":{"address":null,"unit":null,"city":null,"state":null,"zipCode":null,"lotSize":null,"bedrooms":null,"total_baths_calculated":null},"apn":null,"apnOrAddress":"address","properties":[]}


//////////////////
// WEBPACK FOOTER
// ./src/components/utils/properties/resources/model.json
// module id = Z0+f
// module chunks = 1